<template>
  <div v-show="mostrarGraficaPedidos" class="card">
    <div class="card-header">
      <h4 class="card-title">
        {{ $t("pedidosHoras") }}
      </h4>
      <p class="card-category">
        {{ $t("graficaPedidosHoras") }}
      </p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <canvas id="chartPed"></canvas>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <hr />
      <div class="stats">
        <i class="fa fa-clock"></i> {{ lastDate | timeago }}
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import Ticket from "../../../Widgets/Ticket.vue";

export default {
  created() {
    this.getPedidosHoras();
  },
  props: ["onlineDetails", "lastDate", "idBusiness"],
  data() {
    return {
      timeFormat: "HH:mm",
      mostrarGraficaPedidos: false,
    };
  },
  components: {
    Ticket,
  },
  methods: {
    getPedidosHoras() {
      var tpvs = [];
     
      this.onlineDetails.forEach(function(x) {
        if (x && x.online == 1) {
          tpvs.push(x.idTpv);
        }
      });

      var config = {
        params: {
          idBusiness: this.idBusiness,
          listTpv: JSON.stringify(tpvs),
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "online/getPedidosHoras", config)
        .then(function(response) {
          var listPedidosWeb = response.data.result.listPedidos[0];
          var listPedidosTpv = response.data.result.listPedidos[1];
          var existePedidosWeb = false;
          var existePedidosTpv = false;

          for (var i = 0; i < listPedidosWeb.length; i++) {
            if (listPedidosWeb[i].numPedidosWeb !== 0) {
              existePedidosWeb = true;
              break;
            }
          }

          for (var i = 0; i < listPedidosTpv.length; i++) {
            if (listPedidosTpv[i].numPedidosTpv !== 0) {
              existePedidosTpv = true;
              break;
            }
          }
          if (existePedidosWeb || existePedidosTpv) {
            vm.mostrarGraficaPedidos = true;

            if (response.data.response) {
              if (vm.mostrarGraficaPedidos) {
                // add timeout de 0 para que pague el peaje, que si no, no se muestra bien porque
                // no da tiempo a renderizar. IDK...
                setTimeout(() => {
                  vm.initChartPed(response.data.result.listPedidos);
                }, 0);
              }
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    addMinutes(time, minsToAdd) {
      function D(J) {
        return (J < 10 ? "0" : "") + J;
      }
      var piece = time.split(":");
      var mins = piece[0] * 60 + +piece[1] + +minsToAdd;

      return D(((mins % (24 * 60)) / 60) | 0) + ":" + D(mins % 60);
    },

    initChartPed(listPedidos) {
      var pedidosWeb = listPedidos[0];
      var pedidosTpv = listPedidos[1];

      if (pedidosWeb.length > pedidosTpv.length) {
        var labels = pedidosWeb.map(function(x) {
          return x.hour;
        });
      } else {
        var labels = pedidosTpv.map(function(x) {
          return x.hour;
        });
      }

      var data = pedidosWeb.map(function(x) {
        return x.numPedidosWeb;
      });

      var dataTPV = pedidosTpv.map(function(x) {
        return x.numPedidosTpv;
      });

      if (this.$chartPed) {
        this.$chartPed.destroy();
      }

      this.$chartPed = new Chart("chartPed", {
        type: "scatter",
        data: {
          labels: labels,
          datasets: [
            {
              type: "line",
              data: data,
              label: "Pedidos desde Web",
              fill: true,
              borderColor: "rgb(108, 66, 245)",
              backgroundColor: "rgba(108, 66, 245, 0.5)",
              pointBackgroundColor: "rgba(108, 66, 245, 1)",
              // pointBackgroundColor: "rgba(0,0,0,1)",
              // borderColor: "rgba(0,0,0,0.6)",
              // borderWidth: 1
            },
            {
              type: "line",
              label: "Pedidos desde Tpv",
              data: dataTPV,
              fill: true,
              borderColor: "rgb(54, 162, 235)",
              backgroundColor: "rgba(54, 162, 235,0.5)",
              pointBackgroundColor: "rgba(54, 162, 235, 1)",
              // pointBackgroundColor: "rgba(0,0,0,1)",
              // borderColor: "rgba(0,0,0,0.6)",
              // borderWidth: 1
            },
          ],
        },
        options: {
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
            },
          },

          scales: {
            xAxes: [
              {
                type: "time",
                distribution: "series",
                time: {
                  unit: "minute",
                  stepSize: 30, // I'm using 30 min intervals here
                  tooltipFormat: "HH:mm", // <- HERE
                  displayFormats: {
                    millisecond: "HH:mm",
                    second: "HH:mm",
                    minute: "HH:mm",
                    hour: "HH:mm",
                    day: "HH:mm",
                    week: "HH:mm",
                    month: "HH:mm",
                    quarter: "HH:mm",
                    year: "HH:mm",
                  },
                },
                ticks: {
                  major: {
                    enabled: true, // <-- This is the key line
                    fontStyle: "bold", //You can also style these values differently
                    fontSize: 14, //You can also style these values differently
                  },
                },
              },
            ],

            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  alignToPixels: true,
                  stepSize: 5, //este atributo sirve para la escala del numero que queremos representar
                },
                scaleLabel: {
                  display: true,
                  labelString: "Pedidos",
                },
              },
            ],
          },
        },
      });
    },
  },
  watch: {
    onlineDetails: function(newOnlineDetails, oldOnlineDetails) {
      if(this.mostrarGraficaPedidos){
        this.getPedidosHoras();
      }
     
    },
  },
};
</script>
<style scoped>
.card-body {
  padding: 10px 15px;
}

.title {
  font-weight: bold;
}

tfoot tr td {
  font-size: 1.2em;
  color: #fff;
  text-shadow: 1px 1px #111;
  font-weight: bold;
}

.card-category {
  color: #9a9a9a;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/PedidosHoras.vue